import { ModeNamesEnum } from './browse-mode';
import { BrowseTypesEnum } from './browse-types.enum';
import {
  FilterOption,
  getSearchModeFilterOptions,
  getSlopeFilterOptions,
  getSpeedFilterOptions,
} from './filter-options';

export enum FilterNamesEnum {
  Region = 'region',
  SearchMode = 'searchMode',
  WorkoutType = 'workoutType',
  Duration = 'duration',
  Distance = 'distance',
  Slope = 'slope',
  Difficulty = 'difficulty',
  Quality = 'quality',
  Progress = 'progress',
  Sound = 'sound',
  Speed = 'speed',
  Power = 'power',
  Tag = 'tag',
  Language = 'language',
  Equipment = 'equipment',
  InApp = 'inApp',
  ClimbCategory = 'climbCategory',
  // Vehicle = 'vehicle',
  SortDirection = 'sortDirection',
}

export interface BrowseFilter {
  name: FilterNamesEnum;
  label: string;
  icon?: string;
  isRadio?: boolean;
  selectedOptions: FilterOption[];
}

const FILTERS: BrowseFilter[] = [
  {
    label: 'browse.filterSort.filters.searchMode.title',
    icon: 'icon-filtres',
    name: FilterNamesEnum.SearchMode,
    isRadio: true,
    selectedOptions: [getSearchModeFilterOptions()[0]],
  },
  {
    label: 'browse.filterSort.filters.workoutType.title',
    name: FilterNamesEnum.WorkoutType,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.duration.title',
    icon: 'icon-timer',
    name: FilterNamesEnum.Duration,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.distance.title',
    icon: 'icon-distance',
    name: FilterNamesEnum.Distance,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.slope.title',
    icon: 'icon-elevation',
    name: FilterNamesEnum.Slope,
    selectedOptions: getSlopeFilterOptions(),
  },
  {
    label: 'browse.filterSort.filters.difficulty.title',
    name: FilterNamesEnum.Difficulty,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.quality.title',
    name: FilterNamesEnum.Quality,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.progress.title',
    name: FilterNamesEnum.Progress,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.sound.title',
    name: FilterNamesEnum.Sound,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.speed.title',
    name: FilterNamesEnum.Speed,
    selectedOptions: getSpeedFilterOptions(),
  },
  {
    label: 'browse.filterSort.filters.power.title',
    name: FilterNamesEnum.Power,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.tag.title',
    name: FilterNamesEnum.Tag,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.language.title',
    name: FilterNamesEnum.Language,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.equipment.title',
    name: FilterNamesEnum.Equipment,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.inApp.title',
    name: FilterNamesEnum.InApp,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.climbCategory.title',
    name: FilterNamesEnum.ClimbCategory,
    selectedOptions: [],
  },
  // {
  //   label: 'browse.filterSort.filters.vehicle.title',
  //   name: FilterNamesEnum.Vehicle,
  //   selectedOptions: [],
  // },
  {
    label: 'browse.filterSort.filters.region.title',
    name: FilterNamesEnum.Region,
    selectedOptions: [],
  },
  {
    label: 'browse.filterSort.filters.sortDirection.title',
    name: FilterNamesEnum.SortDirection,
    isRadio: true,
    selectedOptions: [{ value: 'desc', label: 'Descending' }],
  },
];

export const getFiltersCopy = () => {
  return [...FILTERS].map((f) => {
    return { ...f };
  });
};

export const getAllFiltersInSearchMode = (
  modeFilter: BrowseFilter
): BrowseFilter[] => {
  let modeName: ModeNamesEnum | null;

  switch (modeFilter.selectedOptions[0].value) {
    case BrowseTypesEnum.Video:
      modeName = ModeNamesEnum.Videos;
      break;
    case BrowseTypesEnum.Coaching:
      modeName = ModeNamesEnum.Coachings;
      break;
    default:
      modeName = null;
  }

  return [modeFilter, ...getAvailableFilters({ modeName })];
};

export const getAvailableFilters = ({
  modeName = null,
  isSearch = false,
}: {
  modeName?: ModeNamesEnum;
  isSearch?: boolean;
}): BrowseFilter[] => {
  let availableFilterNames: FilterNamesEnum[];
  if (isSearch) {
    availableFilterNames = [FilterNamesEnum.SearchMode];
  } else {
    switch (modeName) {
      case ModeNamesEnum.Videos:
        availableFilterNames = [
          FilterNamesEnum.Duration,
          FilterNamesEnum.Distance,
          FilterNamesEnum.Slope,
          FilterNamesEnum.Difficulty,
          FilterNamesEnum.Quality,
          FilterNamesEnum.Progress,
          FilterNamesEnum.Sound,
          FilterNamesEnum.Speed,
          FilterNamesEnum.Power,
          FilterNamesEnum.Tag,
          FilterNamesEnum.InApp,
          FilterNamesEnum.ClimbCategory,
          // FilterNamesEnum.Vehicle,
          FilterNamesEnum.Region,
          FilterNamesEnum.SortDirection,
        ];
        break;
      case ModeNamesEnum.Gps:
        availableFilterNames = [
          FilterNamesEnum.Distance,
          FilterNamesEnum.Slope,
          FilterNamesEnum.SortDirection,
        ];
        break;
      case ModeNamesEnum.Workouts:
        availableFilterNames = [
          FilterNamesEnum.WorkoutType,
          FilterNamesEnum.Duration,
          FilterNamesEnum.Difficulty,
          FilterNamesEnum.SortDirection,
        ];
        break;
      case ModeNamesEnum.Coachings:
        availableFilterNames = [
          FilterNamesEnum.Duration,
          FilterNamesEnum.Difficulty,
          FilterNamesEnum.Sound,
          FilterNamesEnum.Language,
          FilterNamesEnum.Equipment,
          FilterNamesEnum.SortDirection,
        ];
        break;
      default:
        availableFilterNames = [];
    }
  }

  return getFiltersCopy().filter((f) => {
    return availableFilterNames.includes(f.name);
  });
};
